/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-31 16:49:00
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-27 16:46:47
 * @FilePath: /dsicm-admin-web/src/views/questionnaire/common/index.js
 */
export default{
    data(){
        return{
            homeConfig : [
                {
                    label: '序号',
                    align: 'center',
                    width:'80px',
                    render: (h, scope) => {
                        return (
                        <div slot="reference">
                            {scope.$index + 1}
                        </div>
                        )
                    },
                },
                {
                    label: '创建时间',
                    prop: 'createTime',
                    align: 'center',
                },
                {
                    label: '问卷标题',
                    align: 'center',
                    prop: 'title',
                },
                {
                    label: '属性',
                    prop: 'no',
                    align: 'center',
                    prop: 'tagName',
                },
                // {
                //     label: '状态',
                //     align: 'center',
                //     render: (h, scope) => {
                //         return (
                //         <div slot="reference">
                //             {scope.row.passed ? '已发布' :'未发布'}
                //         </div>
                //         )
                //     },
                // },
                {
                    label: '操作',
                    align: 'center',
                    width:'300px',
                    render: (h, scope) => {
                    return h('div', [
                        h( 'el-button', {
                            props: { type: 'text', size: 'mini' },
                            on: {
                                click: () => {
                                    this.showIssue(scope.row)
                                },
                            },
                        },
                        scope.row.passed ? '下架' :'发布'
                        ),
                        h( 'el-button', {
                            props: { type: 'text', size: 'mini' },
                            on: {
                                click: () => {
                                    this.previewVisible(scope.row)
                                },
                            },
                        },
                        '预览'
                        ),
                        h( 'el-button', {
                            props: { type: 'text', size: 'mini' },
                            attrs:{disabled:scope.row.passed},
                            on: {
                                click: () => {
                                    this.$router.push({path:'/addQuestion',query:{
                                        id:scope.row.id
                                    }})
                                },
                            },
                        },
                        '编辑'
                        ),
                        h( 'el-button', {
                            props: { type: 'text', size: 'mini' },
                            attrs:{disabled:!scope.row.passed},
                            on: {
                                click: () => {
                                    this.examId = scope.row
                                    this.pushDiaog = !this.pushDiaog
                                },
                            },
                        },
                        '推送'
                        ),
                    ])
                    },
                },
            ],
                //推送人远
            pushConfig:[
                { 
                align: 'center', 
                type:'selection'
                },
                {
                label: '序号',
                align: 'center',
                render: (h, scope) => {
                    return <div slot="reference">{scope.$index + 1}</div>
                },
                },
                { 
                label: '患者ID', 
                align: 'center', 
                prop: 'patientId' 
                },
                { 
                label: '姓名', 
                align: 'center', 
                prop: 'name' 
                },
                { 
                label: '性别', 
                align: 'center', 
                prop: 'sex' ,
                render: (h, scope) => {
                    return <div slot="reference">{scope.row.sex ==1 ? '男' : '女' }</div>
                },

                },
                { 
                label: '年龄（岁）', 
                align: 'center', 
                prop: 'age' 
                },
                { 
                label: '疾病类型', 
                align: 'center', 
                prop: 'diseaseType' 
                },
            ],
            //病人选择 病人类型
            userTypeList:[
                {
                    label:'全病程',
                    value:'1'
                },
                {
                    label:'住院',
                    value:'2'
                },
                {
                    label:'注册',
                    value:'3'
                },
                {
                    label:'消费',
                    value:'4'
                },
            ],
            //患者来源
            userFromList:[
                {
                    label:'医生',
                    value:'1'
                },
                {
                    label:'护士',
                    value:'2'
                },
                {
                    label:'地推',
                    value:'3'
                },
                {
                    label:'其他',
                    value:'4'
                },
            ],
        }
    }
}
